// 西安市友谊彩钢钢构工程有限公司
const yylb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yylb1.jpg";
const yylb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yylb2.jpg";
const yylb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yylb3.jpg";

const yyzz = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzz.png";
const yyzs1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs1.png";
const yyzs2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs2.png";
const yyzs3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs3.png";
const yyzs4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs4.png";
const yyzs5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs5.png";
const yyzs6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs6.png";
const yyzs7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs7.png";
const yyzs8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs8.png";
const yyzs9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyzs9.png";

const yyhb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyhb1.png";
const yyhb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyhb2.png";
const yyhb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyhb3.png";
const yyhb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyhb4.png";

const yycp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp1.png";
const yycp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp2.png";
const yycp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp3.png";
const yycp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp4.png";
const yycp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp5.png";
const yycp6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp6.png";
const yycp7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp7.png";
const yycp8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp8.png";
const yycp9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yycp9.png";

const yygc1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yygc1.png";
const yygc2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yygc2.png";
const yygc3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yygc3.png";
const yygc4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yygc4.png";

const yyht11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht11.png";
const yyht12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht12.png";
const yyht13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht13.png";
const yyht14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht14.png";
const yyht15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht15.png";
const yyht16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht16.png";
const yyht17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht17.png";
const yyht18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyht18.png";

const yyxc1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc1.png";
const yyxc2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc2.png";
const yyxc3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc3.png";
const yyxc4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc4.png";
const yyxc5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc5.png";
const yyxc6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc6.png";
const yyxc7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc7.png";
const yyxc8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yyxc8.png";

const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
const zbvideoUrl = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbsp.mp4";
const zbvideoLogo = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/zb/zbfm.jpg";
export default {
	homeData: {
		herderBanner: [yylb1, yylb2, yylb3],
		//企业logo
		logo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/logo.jpg",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/yy/yylb2.jpg",
		isShowVrModal: false,
		isShowVr: false,
		vRurl: "",
		isVideo: false,
		videoLogo: zbvideoLogo,
		videoUrl: zbvideoUrl,
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `西安市友谊彩钢钢构工程有限公司成立于2012年，注册资金1068万。公司主营打包箱、K式房、钢结构等临建活动房，可销售、回收、租赁。我们始终“以质量求生存，以信誉求发展，求真务实，继承创新”的宗旨，采用先进管理模式对客户的满意服务为根本，为客户提供安全、美观、舒适的新型活动房。并在发展中不断完善自我，在交易中不断审视自我。在这百废俱兴峥嵘岁月的新世纪里，真诚希望与个界朋友携手共赢美好明天。我们深信，我们永远是各位朋友最值得信赖的合作伙伴。`,
		//公司官网
		website: "",
		operatingStatus: "正常在业",
		//经营品类
		categories: `金属制品销售;金属包装容器及材料销售;耐火材料销售;安防设备销售;集装箱销售; 金属结构销售;对外承包工程;承接总公司工程建设业务; 集装箱租赁服务;机械设备租赁;运输设备租赁服务;仓储设备租赁服务;建筑工程机械与设备租赁。`,
		//公司地址
		companyAddress: "西安市未央区徐家湾秦川路407库",
		site: "西安市未央区",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "1068万人民币",
		//成立日期
		establishment: "2012-1-9",
		//经营品牌
		brand: "友谊",
		//主营产品
		mainProducts: "金属制品销售;金属包装容器及材料销售;耐火材料销售;安防设备销售;集装箱销售; 金属结构销售;对外承包工程;承接总公司工程建设业务; 集装箱租赁服务;机械设备租赁;运输设备租赁服务;仓储设备租赁服务;建筑工程机械与设备租赁。	",
		//企业名称
		headerTitle: "西安市友谊彩钢钢构工程有限公司",
		moreInfoName: "西安市友谊彩钢钢构工程有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `1.现款现结
                       2.预付款（可与其他项组合）
                       3.货到付款
                       4.按工程进度付款
                       5.完工结算
                       6.预留质保金（可与其他项组合）`,
		//工厂地址
		factoryAddress: "--",
		//工厂人数
		factoryHeadcount: "78",
		//产能
		capacity: "暂无信息",
		//年产值  -----> 生产基地总面积
		annualOutputValue: "18000",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "省市布局1-2个",
		factoryHeadcount: "18000",
		capacity: "打包箱年产量3万套",

		//联系负责人
		person: "胡荣玉",
		//联系电话
		contactNumber: "15829673336",
		//资质证书
		// 如果没有一张证书的话 就写： qualificationList:[]
		qualificationList: [
			{
				name: "营业执照",
				path: yyzz,
			},
			{
				name: "安全生产许可证",
				path: yyzs1,
			},
			{
				name: "诚信经营示范单位",
				path: yyzs2,
			},{
				name: "钢结构工程专业承包三级",
				path: yyzs3,
			},{
				name: "钢结构工程专业承包三级",
				path: yyzs4,
			},{
				name: "企业信用等级证书",
				path: yyzs5,
			},{
				name: "职业健康安全管理体系认证证书",
				path: yyzs6,
			},
			{
				name: "质量服务诚信单位",
				path: yyzs7,
			},{
				name: "中国安全施工甲级单位",
				path: yyzs8,
			},
			{
				name: "重质量守信用单位",
				path: yyzs9,
			},
			
		],
		//荣誉证书
		// 如果没有一个荣誉的话 就写： certificateList:[]
		certificateList: [],
		//合作伙伴
		cooperativeList: [
			{
				name: "陕西建工控股集团有限公司",
				path: yyhb1,
				desc: "",
			},
			{
				name: "中国建筑集团有限公司",
				path: yyhb2,
				desc: "",
			},
			{
				name: "中国中铁股份有限公司",
				path: yyhb3,
				desc: "",
			},
			{
				name: "中国铁建股份有限公司",
				path: yyhb4,
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 0,
				num: 10,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 0,
				num: 9,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
	listData: {
		productList: [
			{ name: "箱式房-打包箱", img: yycp1 },
			{ name: "箱式房-彩钢板房", img: yycp4 },
			{ name: "钢结构", img: yycp7 },
		],
		navList: [
			{
				name: "箱式房",
				isShow: false,
				id: 1,
				children: ["打包箱", "彩钢板房"],
			},
			{
				name: "钢结构",
				isShow: false,
				id: 2,
				children: [],
			},
		],
	},
	//产品详情页
	productDetailsData: {
		'箱式房-打包箱': {
			name: "箱式房-打包箱",
			img: yycp1,
			modelNumber: [
				{
					title: "暂无",
					img: yycp1,
				},
			],
			price: "14600",
			detailImgs: [yycp1],
			modelNumberText: "间",
			brand: "友谊",
			describe: `打包箱采用模块化设计理念和生产技术，把一个箱房模块化成标准的零部件，到使用地再现场组装或吊装落位即可，规格6055*2990*2896mm。打包箱可作为办公、住宿、餐厅、卫浴以及组合大空间使用，可满足建筑工地营房、野外作业营房、市政安置用房及各类商业用房的需求。其具有的预制化、灵活性、节能环保等特点，被称为新型“绿色建筑体”。配套齐全 可搭配不同造型的屋顶、走廊、雨棚、楼梯，并可根据需求对外观、内部进行装饰。 安全耐用 拆装无损耗、周转次数多、使用寿命可长达15年-20年以上，抗震度8度，抗风11级。`,
			report: [],
		},

		'箱式房-彩钢板房': {
			name: "箱式房-彩钢板房",
			img: yycp4,
			modelNumber: [
				{
					title: "暂无",
					img: yycp4,
				},
			],
			price: "265",
			detailImgs: [yycp4],
			modelNumberText: "㎡",
			brand: "友谊",
			describe: `活动房是一种以轻钢为骨架，以彩钢复合夹芯板为围护材料，以标准模数系列进行空间组合，构件采用螺栓连接，复合墙体板采用钻尾钉，全新概念的环保经济型活动房屋。可方便快捷地进行组装和拆卸，实现了临时建筑的通用标准化，树立了环保节能、快捷高效的建筑理念，使临时房屋进入了一个系列化开发、集成化生产、配套化供应、可库存和可多次周转使用的定型产品领域。`,
			report: [],
		},

		'钢结构': {
			name: "钢结构",
			img: yycp7,
			modelNumber: [
				{
					title: "暂无",
					img: yycp7,
				},
			],
			price: "--",
			detailImgs: [yycp7],
			modelNumberText: "㎡",
			brand: "友谊",
			describe: `钢结构是由钢制材料组成的结构，是主要的建筑结构类型之一。结构主要由型钢和钢板等制成的钢梁、钢柱、钢桁架等构件组成，并采用硅烷化、纯锰磷化、水洗烘干、镀锌等除锈防锈工艺。各构件或部件之间通常采用焊缝、螺栓或铆钉连接。因其自重较轻，且施工简单，广泛应用于大型厂房、场馆、超高层、桥梁等领域。钢结构容易锈蚀，一般钢结构要除锈、镀锌或涂料，且要定期维护。`,
			report: [],
		},
	},
	//联系我们
	contactListData: {
		list: [
			{
				//	姓名
				name: "胡荣玉",
				//职位 + 负责区域  ， 跟产品对一下 要不要职位+负责区域   还是单个展示一个职位就行了
				position: "总经理",
				//标识 1 2 34 这样给  给不同的就行
				id: "1",
				//手机号
				phoneNum: "15829673336",
				color: "#23B095 ",
				telephone: "",
				//电子邮箱
				email: "286107813@qq.com",
			},
		],
	},
	//工程案例
	caseData: {
		list: [
			{
				name: "西安市儿童医院经开院区项目工程总承包（EPC）工程项目部", //项目名称
				id: 1, //标识 
				price: "274万元", //签约金额
				time: "2020", //签约年份
				site: "陕西省西安市",//项目所在城市
				type: "医院", //项目分类
				unit: "中建八局第二建设有限公司", //甲方单位
				//项目描述
				desc: "西安市儿童医院经开院区位于经开区高铁新城区域内，尚稷路以北、草滩八路以东、尚林路以南、草滩七路以西，规划净用地面积200亩，是市委、市政府强力推进的13个医院重点建设项目之一，自开建以来就备受重视。未来该院区全面启用后，将进一步满足省内及周边地区儿童就医需求，全面优化区域内儿童医疗资源布局，有效提升儿童医疗服务水平，让更多患儿享受高效、优质的医疗服务。",
				//工程图片
				imgList: [{ title: "", path: yygc1 }],
				//现场图片 没有的话就是  proImgList:[],
				proImgList: [{ title: "", path: yyxc1 },
				             { title: "", path: yyxc2 }
			],
				//合同或合作证明截图
				contractList: [
					{ title: "", path: yyht11 },
					{ title: "", path: yyht12 },
				],
				//产品/服务
				product: "临建房",
			},
			{
				name: "西安灞水东苑项目",
				id: 2,
				price: "1014万元",
				time: "2021",
				site: "陕西省西安市",
				type: "方舱医院",
				unit: "陕西建工材料物流集团有限公司",
				desc: "西安浐灞方舱院区是为新型冠状病毒肺炎患者隔离治疗而专设的院区，占地面积约4500平方米；共设有800个床位，陕西建工材料物流集团有限公司承建。",
				imgList: [{ title: "", path: yygc2 }],
				proImgList: [{ title: "", path: yyxc3 },
				             { title: "", path: yyxc4 }

				],
				contractList: [
					{ title: "", path: yyht13 },
					{ title: "", path: yyht14 },
				],
				product: "临建房",
			},
			{
				name: "未来之瞳-瞳系列（大剧院）项目部",
				id: 3,
				price: "319万元",
				time: "2022",
				site: "陕西省西安市",
				type: "剧院",
				unit: "陕西建工第八建设集团有限公司",
				desc: "未来之瞳系列建筑项目位于西安高新区丝路科学城片区核心区域，东邻西太路，西邻经二十二路，规划用地面积约140亩，总建筑面积约19万平方米。作为丝路科学城区域最重要的文化配套设施，未来之瞳是集科创研发、办公、星级酒店等功能为一体的核心引擎，配套大剧院、音乐厅、美术馆、空中景观步道等，目前区内各项工程正在稳步推进，建成后将打造出西安的最美天际线，成为西安文化新地标。",
				imgList: [{ title: "", path: yygc3 }],
				proImgList: [{ title: "", path: yyxc5},
				             { title: "", path: yyxc6 }

				],
				contractList: [
					{ title: "", path: yyht15 },
					{ title: "", path: yyht16 },
				],
				product: "临建房",
			},
			{
				name: "西安草堂健康营地项目",
				id: 4,
				price: "2183万",
				time: "2022",
				site: "陕西省西安市",
				type: "房屋",
				unit: "中建八局第二建设有限公司",
				desc: "西安草堂方舱院区是为新型冠状病毒肺炎患者隔离治疗而专设的院区，占地面积约8000平方米，共设有2000个床位，中建八局第二建设有限公司承建",
				imgList: [{ title: "", path: yygc4 }],
				proImgList: [{ title: "", path: yyxc7 },
				             { title: "", path: yyxc8 }

				],
				contractList: [
					{ title: "", path: yyht17 },
					{ title: "", path: yyht18 },
				],
				product: "临建房",
			},
		],
	},
	//综合评价
	evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			//只用管这个 法律诉讼
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				//number:就是产品提供的企业的案件数量 大于0的话  isShow:true,    等于0-> isShow:false
				isShow: false,
				number: 2,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/cccf.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				// title: 'CCCF消防认证',
				subtitle: "CCCF消防认证",
				isShow: true,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${6}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${6}.png`,
				// title: '央视展播品牌',
				subtitle: "央视展播品牌",
				isShow: true,
			},
		],
	},
	//中标信息
	successfulBidderData: {
		//没有的话 info:[]
		info: [{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "西安东站站前西广场综合枢纽一期工程EPC项目",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工第六建设集团有限公司",
			//工程项目
			name2: "西安东站站前西广场综合枢纽一期工程EPC项目",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2023年6月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "科源二路规划路项目",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工集团股份有限公司铁建工程部",
			//工程项目
			name2: "科源二路规划路项目",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2022年7月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "雁南朗境项目一标段",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工集团股份有限公司工程五部",
			//工程项目
			name2: "雁南朗境项目一标段",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2023年4月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "西安市新冠方舱医院活动房采购",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工第七建设集团有限公司",
			//工程项目
			name2: "浐灞方舱医院改造设计项目",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2022年4月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "陕广电项目停车棚专业分包",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西古建园林建设集团有限公司",
			//工程项目
			name2: "陕西广播电视发展基地（二期）暨中国（陕西）国家级融媒体综合实验区",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2021年10月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "陕西建工机械施工集团有限公司绥德革命纪念馆临建专业分包",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工机械施工集团有限公司",
			//工程项目
			name2: "绥德革命纪念馆工程			",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2020年12月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "高品质钛锭、管材、型材生产线建设项目/宇航级宽幅钛合金板材、带箔材建设项目--管型材及带箔材厂房--施工临建房采购",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工第八建设集团有限公司",
			//工程项目
			name2: "高品质钛锭、管材、型材生产线建设项目/宇航级宽幅钛合金板材、带箔材建设项目--管型材及带箔材厂房--施工",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2021年1月",
			out: true,
		},
        {
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "三原高新区第二污水处理厂工程（一期）工程总承包打包箱，活动板房采购",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西华山路桥集团有限公司",
			//工程项目
			name2: "三原高新区第二污水处理厂工程（一期）工程总承包",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2020年8月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "西安航天基地军B区活动房",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工第六建设集团有限公司",
			//工程项目
			name2: "西安航天基地军民融合创新园B区施工工程",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "2019年8月",
			out: true,
		},
		{
			企业名称: "西安市友谊彩钢钢构工程有限公司",
			//招标名称
			name1: "陕建一建四公司蓝田养老小镇项目活动房",
			//单位  到时候看一下 应该是单位之类的
			name4: "陕西建工第一建设集团有限公司",
			//工程项目
			name2: "西安世茂南山养老小镇",
			//类型
			name3: "专业分包", 
			//发布时间
			date: "/",
			out: true,
		},
		]
			
	},
	//法律诉讼的详情
	lawData: {
		// 如果没有一条的话 info:[],
		info: [],
			
	},
	//这里是店铺详情页 顶部 公司名称下面的小标签
	tipData: {
		info: [
			{
				title: "陕建云采会员",

			},	
			{
				title: "成立10年以上",
				
			},	
		],
	},
};